import { styled } from '@mui/material/styles';

export const Nav = styled('nav')({
    display: 'flex',
    alignItems: 'center',
});

export const List = styled('ul')({
    listStyle: 'none',
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    paddingLeft: 0,
});
